import gsap from "gsap"

export function initfiltering() {
  const filters = document.querySelectorAll(".filter-btn")
  const projects = document.querySelectorAll(".project-card")

  if (!filters.length || !projects.length) return

  // Helper function to apply a filter by name
  function applyFilter(value, updateUrl = true) {
    // 1. Update URL query parameter without page refresh
    if (updateUrl) {
      const url = new URL(window.location.href)
      if (value === "all" || !value) {
        url.searchParams.delete("category")
      } else {
        url.searchParams.set("category", value)
      }
      window.history.pushState({}, "", url)
    }

    // 2. Update active button states
    filters.forEach(btn => {
      if (btn.dataset.filter === value) {
        btn.classList.add("bg-black", "text-white")
      } else {
        btn.classList.remove("bg-black", "text-white")
      }
    })

    // 3. Filter projects with GSAP animations
    projects.forEach(project => {
      const categories = (project.dataset.category || "").split(" ")
      const visible = value === "all" || categories.includes(value)

      if (visible) {
        project.classList.remove("hidden")

        gsap.fromTo(
          project,
          {
            opacity: 0,
            scale: 0.95
          },
          {
            opacity: 1,
            scale: 1,
            duration: 0.35
          }
        )
      } else {
        gsap.to(project, {
          opacity: 0,
          scale: 0.95,
          duration: 0.2,
          onComplete() {
            project.classList.add("hidden")
          }
        })
      }
    })
  }

  // --- Event Listeners --- //

  // Click handler for filter buttons
  filters.forEach(filter => {
    filter.addEventListener("click", () => {
      const value = filter.dataset.filter
      applyFilter(value, true)
    })
  })

  // Read URL query parameter on page load (e.g., ?category=architecture)
  const urlParams = new URLSearchParams(window.location.search)
  const initialCategory = urlParams.get("category") || "all"

  // Apply initial filter if a category parameter exists
  applyFilter(initialCategory, false)

  // Handle back/forward browser navigation
  window.addEventListener("popstate", () => {
    const currentParams = new URLSearchParams(window.location.search)
    const activeCategory = currentParams.get("category") || "all"
    applyFilter(activeCategory, false)
  })
}
